<template>
	<div id="legal">
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="inner" v-html="ppmDetail"></div>
	</div>
</template>

<script>
export default {
	name: 'PrivacyPolicyMatrix',
	data() {
		return {
			ppmDetail: [],
		};
	},
	created() {
		this.$http.get(`${this.cdnHost}/frontend/v2/${environment.region}/ppm/${this.$i18n.locale}.json`).then((response) => {
			this.ppmDetail = response.data;
		});
	},
};
</script>

<style scoped>
.inner::v-deep a {
	color: blue;
	text-decoration: underline;
}
</style>
